import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_PROJECT_AC_CENTRAL',
  LIST_GROUPS: 'LIST_PROJECT_AC_CENTRAL_GROUPS',
  CREATE: 'ADD_PROJECT_AC_CENTRAL',
  BIND: 'BIND_PROJECT_AC_CENTRAL',
  DELETE: 'DELETE_PROJECT_AC_CENTRAL',
  UNBIND_GROUP: 'UNBIND_PROJECT_AC_CENTRAL_GROUP',
  CLEAR_ERROR: 'CLEAR_ERROR_PROJECT',
};

export const listACCentralInBuilding = (pageSize, page, sorted, filtered, isPublic, buildingId) => {
  return {
    type: ACTION.LIST,
    payload: RestClient.request({
      method: 'get',
      url: Constants.API_PROJECT_AC_CENTRAL,
      params: {
        search: filtered,
        limit: pageSize,
        offset: pageSize * page,
        ordering: sorted
          ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
          : null,
        is_public: isPublic,
        building_id: buildingId,
      }
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addACCentralToBuilding = (acCentralId, buildingId, quantity) => {
  const data = {
    ac_central_id: acCentralId,
    building_id: buildingId,
    quantity: quantity,
  };

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_PROJECT_AC_CENTRAL,
      data,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const removeACCentralFromBuilding = (projectACCentralId, buildingId) => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_PROJECT_AC_CENTRAL}${projectACCentralId}/`,
    })
      .then(() => ({ id: projectACCentralId, building_id: buildingId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const listACCentralGroupsInProject = (projectId) => {
  return {
    type: ACTION.LIST_GROUPS,
    payload: RestClient.request({
      method: 'get',
      url: Constants.API_PROJECT_AC_CENTRAL_GROUPS(projectId),
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const bindACCentralToProject = (projectId, acCentralId) => {
  return {
    type: ACTION.BIND,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_PROJECT_BIND_AC_CENTRAL(projectId),
      data: { ac_central_id: acCentralId },
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const clearErrorProjectACCentral = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const unbindACCentralGroupFromProject = (projectId, acCentralIds) => {
  return {
    type: ACTION.UNBIND_GROUP,
    payload: RestClient.request({
      method: 'delete',
      url: Constants.API_PROJECT_UNBIND_AC_CENTRAL_GROUP(projectId),
      data: { ac_central_ids: acCentralIds },
    })
      .then(() => ({ ac_central_ids: acCentralIds }))
      .catch(err => Promise.reject(err.response.data)),
  };
};


// WEBPACK FOOTER //
// ./src/redux/projects/project_ac_central_actions.js